module.exports = __webpack_public_path__ + "img/71.decb14a9.jpg";